import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Account from "../../components/Account/Account";
import ConsultantDashboard from "../../components/consultant-dashboard/ConsultantDashboard";
import QADashboard from "../../components/consultant-dashboard/QAdashboard";
import Customers from "../../components/Customers/Cutomers";
import Dashboard from "../../components/Dashboard/Dashboard";
import Drivers from "../../components/Drivers/Drivers";
import Events from "../../components/Events/Events";
import Technicians from "../../components/Facility-Management/Technicians/Technicians";
import FormBuilder from "../../components/FormBuilder/FormBuilder";
import FSMDashboard from "../../components/fsmDashboard/FSMDashboard";
import Groups from "../../components/Groups/Groups";
import PlayBack from "../../components/HistoryPlayBack/PlayBack";
import InspectionRequest from "../../components/InspectionRequest/InspectionRequest";
import IRHistory from "../../components/IRHistory/IRHistory";
import DeleteAccount from "../../components/Delete Account/DeleteAccount";
import LiveTracking from "../../components/LiveTracking/LiveTracking";
import MaintenanceRequests from "../../components/Maintenance/MaintenanceRequests/MaintenanceRequests";
import MaintenanceSchedule from "../../components/Maintenance/MaintenanceSchedule/MaintenanceSchedule";
import RegularMaintenance from "../../components/Maintenance/RegularMaintenance/RegularMaintenance";
import Workorders from "../../components/Maintenance/WorkOrders/Workorders";
import Notification from "../../components/Notifications/Notification";
import POIs from "../../components/POIs/POIs";
import POIsWorkload from "../../components/POIs/WorkloadHeatMap/POIsWorkload";
import Report from "../../components/Reports/Report";
import Reports from "../../components/Reports/Reports";
import ReportTypes from "../../components/Reports/ReportsTypes/ReportTypes";
import WorkforceReport from "../../components/Reports/WorkforceReport";
import ClientReportRunner from "../../components/Reports/ClientReportRunner";
import Requests from "../../components/Requests/Requests";
import CallCenter from "../../components/CallCenter/CallCenter";
import Dispatcher from "../../components/Dispatcher/Dispatcher";
import LocationRequests from "../../components/LocationRequests/LocationRequests";
import CancelationRequests from "../../components/CancelationRequests/CancelationRequests";
import DispatcherDetails from "../../components/Dispatcher/DispatcherDetails/DispatcherDetails";
import RolesPermissions from "../../components/Roles&Permissions/RolesPermissions";
import SnagList from "../../components/Snag/SnagList";
import LiveStreaming from "../../components/Streaming/LiveStream/LiveStreaming";
import VideoPlayback from "../../components/Streaming/VideoPlayback/VideoPlayback";
import ModStreaming from "../../components/ModStreaming/ModStreaming";
import ModPlayback from "../../components/ModPlayback/ModPlayback";
import Submittals from "../../components/Submittals/Submittals";
import Tasks from "../../components/Tasks/Tasks";
import RecurringPlanners from "../../components/RecurringPlanners/RecurringPlanners";
import Users from "../../components/Users/Users";
import Vehicles from "../../components/Vehicles/Vehicles";
import Forms from "../../components/Workforce/Forms/Forms";
import FormSubmission from "../../components/Workforce/Forms/Submission/FormSubmission";
import ProtectedRoutes from "../../ProtectedRoutes/ProtectedRoutes";
import trans from "..";
import usePermission from "../../hooks/usePermission";
import Projectsetup from "../../components/ProjectSetup/Projectsetup";
import SetupControl from "../../components/ProjectSetup/ProjectSetupControl/SetupControl";
import Companies from "../../components/Companies/Companies";
import SnagReport from "../../components/SnagReport/SnagReport";
import AnalyticsReports from "../../components/Analytics/AnalyticsReports";
import Teams from "../../components/Teams/Teams";
import LiveTrackingV2 from "../../components/LiveTracking-v2/LiveTracking";
import { useCheckSessionQuery } from "../../Redux/service/Users/AuthUsers";
import Loader from "../../components/Helpers/Loader/Loader";
import TermsAndConditions from "../../components/TermsAndConditions/TermsAndConditions";
import OfflineSetup from "../../components/OfflineSetup/OfflineSetup";
import OfflineSetupControl from "../../components/OfflineSetup/OfflineSetupControl/OfflineSetupControl";
import IR from "../../components/OfflineModules/IR/IR";
import IROfflineControl from "../../components/OfflineModules/IR/IROfflineControl/IROfflineControl";
import SnagOfflineControl from "../../components/OfflineModules/Snag/SnagOfflineControl/SnagOfflineControl";
import Snag from "../../components/OfflineModules/Snag/Snag";
import OfflineRequestsHandle from "../../components/OfflineRequestsHandling/OfflineRequestsHandle";
import NearMiss from "../../components/Workforce/Forms/Submission/Nearmiss";
import { Navigate } from "react-router-dom";
import DispatcherPlans from "../../components/Dispatcher/DispatcherPlans/DispatcherPlans";

const RoleBasedDashboard = () => {
	// Always call all hooks unconditionally to avoid hooks order issues
	const location = useLocation();
	const user = useSelector((state) => state.users.user);
	const role = user?.attributes?.role;
	const dashboardPermission = usePermission("DASHBOARD");
	const fsmDashboardPermission = usePermission("FSMDASHBOARD");
	const fsmDashboardPermissionAlt = usePermission("DASHBOARDFS"); // Support alternative module key
	const consultantDashboardPermission = usePermission("CONSULTANTDASHBOARD");
	const qaDashboardPermission = usePermission("DASHBOARDQAQC");
	const { isLoading, isFetching } = useCheckSessionQuery();
	if (isLoading || isFetching)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);

	// Check the current route first, then verify permissions
	const pathname = location.pathname;

	// Route-specific logic: check which dashboard route we're on
	if (pathname.includes("/dashboard/fsm")) {
		if (fsmDashboardPermission?.view || fsmDashboardPermissionAlt?.view) {
			return <FSMDashboard />;
		}
		// Fallback if no FSM permission
		if (dashboardPermission?.view) {
			return <Dashboard />;
		}
		return <Account />;
	}

	if (pathname.includes("/dashboard/consultant")) {
		if (consultantDashboardPermission?.view) {
			return <ConsultantDashboard />;
		}
		return <Account />;
	}

	if (pathname.includes("/dashboard/qa")) {
		if (qaDashboardPermission?.view) {
			return <QADashboard />;
		}
		return <Account />;
	}

	// Default /dashboard route - check Tracking Dashboard permission first
	if (dashboardPermission?.view) {
		return <Dashboard />;
	}

	// Fallback: if no tracking dashboard permission, check other dashboards
	if (fsmDashboardPermission?.view || fsmDashboardPermissionAlt?.view) {
		return <FSMDashboard />;
	}
	if (consultantDashboardPermission?.view) {
		return <ConsultantDashboard />;
	}
	if (qaDashboardPermission?.view) {
		return <QADashboard />;
	}

	// Default fallback - always return something
	return <Account />;

	// Fallback to role-based logic if no permissions found
	// switch (role) {
	// 	case "consultant":
	// 		return <QADashboard />;

	// 	case "contractor":
	// 		return <QADashboard />;

	// 	case "qa":
	// 		return <QADashboard />;
	// 	case "subContractor":
	// 		return <QADashboard />;

	// 	case "fieldStaff":
	// 		return <FSMDashboard />;

	// 	case "supervisor":
	// 		return <FSMDashboard />;

	// 	default:
	// 		return <Dashboard />;
	// }
};
const OfflineRouting = () => {
	const location = useLocation();
	const offlineMode = useSelector((state) => state.users.offlineMode);
	const pathname = location.pathname;

	switch (true) {
		case pathname.includes("IR"):
			return !offlineMode ? <InspectionRequest /> : <IR />;
		case pathname.includes("snag-list"):
			return !offlineMode ? <SnagList /> : <Snag />;
		default:
			return null;
	}
};

const NearMissRoute = () => {
	// Strictly permission-driven: only users granted the Near Miss (Safety) permission.
	const { view: canNearMiss } = usePermission("NEAR_MISS");

	if (!canNearMiss) {
		return <Navigate to="/dashboard" replace />;
	}

	return <NearMiss />;
};

export const Routes = [
	{
		index: true,
		element: (
			<ProtectedRoutes>
				<Account />
			</ProtectedRoutes>
		),
	},
	{
		path: "dashboard",
		element: (
			<ProtectedRoutes>
				<RoleBasedDashboard />
			</ProtectedRoutes>
		),
	},
	{
		path: "dashboard/fsm",
		element: (
			<ProtectedRoutes>
				<FSMDashboard />
			</ProtectedRoutes>
		),
	},
	{
		path: "dashboard/consultant",
		element: (
			<ProtectedRoutes>
				<ConsultantDashboard />
			</ProtectedRoutes>
		),
	},
	{
		path: "dashboard/qa",
		element: (
			<ProtectedRoutes>
				<QADashboard />
			</ProtectedRoutes>
		),
	},
	{
		path: "livetracking",

		element: (
			<ProtectedRoutes>
				<LiveTrackingV2 />
			</ProtectedRoutes>
		),
	},
	// {
	// 	path: "new-livetracking",
	// 	element: <LiveTrackingV2 />,
	// },
	{
		path: "geofences",
		element: (
			<ProtectedRoutes>
				<LiveTracking />
			</ProtectedRoutes>
		),
	},
	{
		path: "historyplayback/:id",
		element: (
			<ProtectedRoutes>
				<PlayBack />
			</ProtectedRoutes>
		),
	},
	{
		path: "historical",

		element: (
			<ProtectedRoutes>
				<PlayBack />
			</ProtectedRoutes>
		),
	},
	{
		path: "groups",

		element: (
			<ProtectedRoutes>
				<Groups />
			</ProtectedRoutes>
		),
	},
	{
		path: "fleetmanagement",

		children: [
			{
				key: "fms.vehicles",
				path: "vehicles",
				element: (
					<ProtectedRoutes>
						<Vehicles key="vehicles" />
					</ProtectedRoutes>
				),
			},
			{
				key: "fms.drivers",
				path: "drivers",
				element: (
					<ProtectedRoutes>
						<Drivers key="drivers" />
					</ProtectedRoutes>
				),
			},
		],
	},
	{
		path: "notifications",
		children: [
			{
				path: "all",
				element: (
					<ProtectedRoutes>
						<Events />
					</ProtectedRoutes>
				),
			},
			{
				path: "configuration",
				element: (
					<ProtectedRoutes>
						<Notification />
					</ProtectedRoutes>
				),
			},
		],
	},
	{
		path: "maintenance",
		children: [
			{
				path: "regularMaintenance",
				element: (
					<ProtectedRoutes>
						<RegularMaintenance />
					</ProtectedRoutes>
				),
			},
			{
				path: "maintenanceSchedule",
				element: (
					<ProtectedRoutes>
						<MaintenanceSchedule />
					</ProtectedRoutes>
				),
			},
		],
	},
	{
		path: "reports",
		element: (
			<ProtectedRoutes>
				<Reports />
			</ProtectedRoutes>
		),
		children: [
			{
				path: "",
				element: (
					<ProtectedRoutes>
						<ReportTypes />
					</ProtectedRoutes>
				),
			},
			{
				path: "Vehicles/:reportName",
				element: (
					<ProtectedRoutes>
						<Report />
					</ProtectedRoutes>
				),
			},
			{
				path: "fieldservices/:reportName",
				element: (
					<ProtectedRoutes>
						<WorkforceReport />
					</ProtectedRoutes>
				),
			},
			{
				path: "inventory/:reportName",
				element: (
					<ProtectedRoutes>
						<WorkforceReport />
					</ProtectedRoutes>
				),
			},
			{
				path: "client/:reportId",
				element: (
					<ProtectedRoutes>
						<ClientReportRunner />
					</ProtectedRoutes>
				),
			},
		],
	},
	{
		path: "streaming",
		children: [
			{
				path: "live",
				element: (
					<ProtectedRoutes>
						<LiveStreaming />
					</ProtectedRoutes>
				),
			},
			{
				path: "playback",
				element: (
					<ProtectedRoutes>
						<VideoPlayback />
					</ProtectedRoutes>
				),
			},
		],
	},
	{
		path: "mod-streaming",
		element: (
			<ProtectedRoutes>
				<ModStreaming />
			</ProtectedRoutes>
		),
	},
	{
		path: "mod-playback",
		element: (
			<ProtectedRoutes>
				<ModPlayback />
			</ProtectedRoutes>
		),
	},
	{
		path: "forms",
		children: [
			{
				path: "all",
				element: (
					<ProtectedRoutes>
						<Forms />
					</ProtectedRoutes>
				),
			},
			{
				path: "formbuilder",
				element: (
					<ProtectedRoutes>
						<FormBuilder />
					</ProtectedRoutes>
				),
			},
			{
				path: "formbuilder/:id",
				element: (
					<ProtectedRoutes>
						<FormBuilder />
					</ProtectedRoutes>
				),
			},
			{
				path: "submission",
				element: (
					<ProtectedRoutes>
						<FormSubmission />
					</ProtectedRoutes>
				),
			},
		],
	},
	{
		path: "near-miss",
		element: (
			<ProtectedRoutes>
				<NearMissRoute />
			</ProtectedRoutes>
		),
	},
	{
		path: "facility-management",
		children: [
			{
				path: "technicians",
				element: (
					<ProtectedRoutes>
						<Technicians />
					</ProtectedRoutes>
				),
			},
		],
	},
	{
		path: "tasks",
		children: [
			{
				path: "tasks-board",
				element: (
					<ProtectedRoutes>
						<Tasks />
					</ProtectedRoutes>
				),
			},
			{
				path: "heatmap",
				element: (
					<ProtectedRoutes>
						<POIsWorkload />
					</ProtectedRoutes>
				),
			},
			{
				path: "recurring-planners",
				element: (
					<ProtectedRoutes>
						<RecurringPlanners />
					</ProtectedRoutes>
				),
			},
		],
	},
	{
		path: "/point-of-interest",
		element: (
			<ProtectedRoutes>
				<POIs />
			</ProtectedRoutes>
		),
	},
	{
		path: "/tasks-board",
		element: (
			<ProtectedRoutes>
				<Tasks />
			</ProtectedRoutes>
		),
	},
	{
		path: "/requests",
		element: (
			<ProtectedRoutes>
				<Requests />
			</ProtectedRoutes>
		),
	},
	{
		path: "/heatmap",
		element: (
			<ProtectedRoutes>
				<POIsWorkload />
			</ProtectedRoutes>
		),
	},
	{
		path: "IR",
		element: (
			<ProtectedRoutes>
				<OfflineRouting />
			</ProtectedRoutes>
		),
	},
	{
		path: "IR-offline-control/:id?",
		element: (
			<ProtectedRoutes>
				<IROfflineControl />
			</ProtectedRoutes>
		),
	},
	{
		path: "IR-History",
		element: (
			<ProtectedRoutes>
				<IRHistory />
			</ProtectedRoutes>
		),
	},

	{
		path: "Submittals",
		element: (
			<ProtectedRoutes>
				<Submittals />
			</ProtectedRoutes>
		),
	},

	{
		path: "/snag-list",
		element: (
			<ProtectedRoutes>
				<OfflineRouting />
			</ProtectedRoutes>
		),
	},
	{
		path: "snag-offline-control/:id?",
		element: (
			<ProtectedRoutes>
				<SnagOfflineControl />
			</ProtectedRoutes>
		),
	},
	{
		path: "/snag-report",
		element: (
			<ProtectedRoutes>
				<SnagReport />
			</ProtectedRoutes>
		),
	},
	{
		path: "offline-requests",
		element: (
			<ProtectedRoutes>
				<OfflineRequestsHandle />
			</ProtectedRoutes>
		),
	},
	{
		path: "setup",
		children: [
			{
				path: "roles&permissions",
				element: (
					<ProtectedRoutes>
						<RolesPermissions />
					</ProtectedRoutes>
				),
			},
			{
				path: "project-setup",
				element: (
					<ProtectedRoutes>
						<Projectsetup />
					</ProtectedRoutes>
				),
			},
			{
				path: "offline-setup",
				element: (
					<ProtectedRoutes>
						<OfflineSetup />
					</ProtectedRoutes>
				),
			},
			{
				path: "offline-setup-control",
				element: (
					<ProtectedRoutes>
						<OfflineSetupControl />
					</ProtectedRoutes>
				),
			},
			{
				path: "offline-setup-control/:id",
				element: (
					<ProtectedRoutes>
						<OfflineSetupControl />
					</ProtectedRoutes>
				),
			},
			{
				path: "project-setup-control",
				element: (
					<ProtectedRoutes>
						<SetupControl />
					</ProtectedRoutes>
				),
			},
			{
				path: "account",
				element: (
					<ProtectedRoutes>
						<Account />
					</ProtectedRoutes>
				),
			},
			{
				path: "companies",
				element: (
					<ProtectedRoutes>
						<Companies />
					</ProtectedRoutes>
				),
			},
			{
				path: "teams",
				element: (
					<ProtectedRoutes>
						<Teams />
					</ProtectedRoutes>
				),
			},
		],
	},
	{
		path: "delete-account",
		element: (
			<ProtectedRoutes>
				<DeleteAccount />
			</ProtectedRoutes>
		),
	},
	{
		path: "/call-center",
		element: (
			<ProtectedRoutes>
				<CallCenter />
			</ProtectedRoutes>
		),
	},
	{
		path: "dispatcher",
		element: (
			<ProtectedRoutes>
				<Dispatcher />
			</ProtectedRoutes>
		),
	},
	{
		path: "dispatcher-plans",
		element: (
			<ProtectedRoutes>
				<DispatcherPlans />
			</ProtectedRoutes>
		),
	},
	{
		path: "dispatcher/:id",
		element: (
			<ProtectedRoutes>
				<DispatcherDetails />
			</ProtectedRoutes>
		),
	},
	{
		path: "location-requests",
		element: (
			<ProtectedRoutes>
				<LocationRequests />
			</ProtectedRoutes>
		),
	},
	{
		path: "cancelation-requests",
		element: (
			<ProtectedRoutes>
				<CancelationRequests />
			</ProtectedRoutes>
		),
	},
	{
		path: "analytics",
		element: (
			<ProtectedRoutes>
				<AnalyticsReports />
			</ProtectedRoutes>
		),
	},
];
